import { useEffect } from 'react';
import { getAllAdminCampaigns } from 'features/admin-campaigns/async';
import { adminCampaignsDataSelector } from 'features/admin-campaigns/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export function useFetchAdminCampaignsEffect() {
  const dispatch = useAppDispatch();
  const campaigns = useAppSelector(adminCampaignsDataSelector);

  useEffect(() => {
    if (campaigns != null) {
      return;
    }

    dispatch(getAllAdminCampaigns());
  }, [dispatch, campaigns]);
}
